const shopify = {
  footerMessagePaymentVia: 'Ödeme yöntemi',
  inputCustomerName: 'Ad Soyad',
  inputCardExpiryDate: 'Son kullanma tarihi',
  errorInsertCardExpiration: 'Lütfen kartın son kullanma tarihini girin',
  errorCardExpired: 'Girdiğiniz kartın süresi dolmuş',
  errorInvalidExpirationDate: 'Son kullanma tarihi geçersiz',
  inputCardNumber: 'Kart numarası',
  inputCardSecurityCode: 'Güvenlik kodu (CVV)',
  greeting: 'Merhaba, {customerName}',
  fillCardSecurityCode: 'Kartın güvenlik kodunu tamamlayın',
  invalidSecurityCode: 'Geçersiz güvenlik kodu',
  invalidCvv: 'Geçersiz güvenlik kodu',
  fillColombianAddress: 'Adres alanını doldurun.',
  invalidColombianAddress: 'Geçersiz adres.',
};

module.exports = shopify;
